import { Box, Stack, styled, Typography } from '@mui/material';

interface PageContentHeadingProps {
    title?: string | React.ReactNode;
    subtitle?: string | React.ReactNode;
    caption?: string | React.ReactNode;
    actions?: React.ReactNode;
    stackOnMobile?: boolean;
    className?: string;
}

export default function PageContentHeading({ title, subtitle, actions, stackOnMobile, caption, className }: PageContentHeadingProps) {
    return (
        <Root stackOnMobile={ stackOnMobile }
            className={ className }
        >
            <Box>
                { title && (
                    <Typography variant="h4"
                        fontWeight="bold"
                    >
                        { title }
                    </Typography>
                ) }

                { caption && (
                    <Typography variant="caption"
                        gutterBottom
                    >
                        { caption }
                    </Typography>
                ) }

                { subtitle && (
                    <Typography variant="body2"
                        color="text.secondary"
                        gutterBottom
                    >
                        { subtitle }
                    </Typography>
                ) }
            </Box>
            { actions }
        </Root>
    );
}

const Root = styled(Stack, {
    shouldForwardProp: (prop) => prop !== 'stackOnMobile'
})<{ stackOnMobile?: boolean }>(({ theme, stackOnMobile }) => ({
    flexDirection: 'row',
    columnGap: theme.spacing(1),
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(6),
    ...(stackOnMobile && {
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            rowGap: theme.spacing(2)
        }
    })
}));
